import React from "react";
import {DialogActions, DialogContent, DialogTitle, Divider} from "@mui/material";
import Dialog from "../../base/dialog";
import {Row} from "reactstrap";
import Button from "../../base/button/button";
import Banner from "../../app-specific/banner";
import {bannerWidthToHeightRatio} from "../../../../core/constants/enums";

const PreviewBannerDialog = ({
                                 open,
                                 close,
                                 bannerIcon,
                                 removeBannerTagConnectionCallBack,
                                 reconnectBannerToTagCallBack,
                                 isDeletedAlready
                             }) => {


    return (
        <>
            <Dialog
                open={open}
                setOpen={() => close()}
                maxWidth={'md'}
                className={'bound-dialog'}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
            >
                <DialogTitle id={'scroll-dialog-title'}>
                    <p className={`text-lg text-color-1 my-3 font-weight-bold text-center`}>
                        Banner Preview
                    </p>
                    <Divider className='divider'/>
                </DialogTitle>
                <DialogContent className={'px-4 py-4'}>
                    <Banner
                        widthToHeightAspectRatio={bannerWidthToHeightRatio}
                        url={bannerIcon}
                    />
                </DialogContent>
                <DialogActions className={'p-0'}>
                    <Row className={'w-100 no-gutters'}>
                        <Divider className='divider'/>
                        <Row className='no-gutters justify-content-between align-items-start w-100'>
                            <Button
                                disabled={!open}
                                variant={'dialog'}
                                color={'primary'}
                                onClick={close}
                                borderRadius={'0 8px 0 8px'}
                            >
                                Close
                            </Button>
                            <Button
                                disabled={!open}
                                variant={'dialog'}
                                color={'primary'}
                                onClick={isDeletedAlready ? reconnectBannerToTagCallBack : removeBannerTagConnectionCallBack}
                                borderRadius={'8px 0 8px 0'}
                            >
                                {isDeletedAlready ? "Reconnect Again" : "Delete Connection"}
                            </Button>
                        </Row>
                    </Row>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default PreviewBannerDialog;
